import React from 'react';
import PropTypes from 'prop-types';

export default function IconSearchBlack({ className = '' }) {
    return (
        <svg
            className={className}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="search"
        >
            <g id="rightItem_1">
                <g id="Group 7">
                    <path
                        id="Vector"
                        d="M17.0666 24.5333C21.1904 24.5333 24.5333 21.1904 24.5333 17.0666C24.5333 12.9429 21.1904 9.59998 17.0666 9.59998C12.9429 9.59998 9.59998 12.9429 9.59998 17.0666C9.59998 21.1904 12.9429 24.5333 17.0666 24.5333Z"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_2"
                        d="M26.4 26.4L22.6667 22.6666"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
        </svg>
    );
}

IconSearchBlack.propTypes = {
    className: PropTypes.string
};


